<template>
  <div>
    <loading :active.sync="isLoading" :loader="'dots'" :color="'#2759ab'" :can-cancel="false" :is-full-page="true"></loading>
    <vue-headful title="Credimóvil | Socios comerciales"/>
    <menu-component></menu-component>

    <!-- Banner Area -->
    <section class="banner_area banner_area_4">
      <div class="container">
        <h6>Aumenta tus ventas</h6>
        <h2>Ofrece un crédito y anuncia tus autos</h2>
        <ol class="breadcrumb">
                <li></li>
                <li></li>
            </ol>
      </div>
    </section>
    <!-- Banner Area -->

    <!-- Potential Area -->
    <section class="potential_area poa_2 bene_credict">
        <div class="container">
            <div class="tittle">
                <h2>Credimóvil es la herramienta <span>ideal para crecer tus ventas</span> </h2>
                <p>Conoce los grandes beneficios para tu negocio</p>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-6 wow fadeIn" data-wow-delay="0.9s">
                    <div class="potential">
                        <div class="ptl_containt">
                            <div class="loan_img">
                                <img src="images/icons/nuevos-clientes.png" alt="Nuevos clientes">
                            </div>
                            <a class="heding">Llega a más personas</a>
                            <h6>y gana nuevos clientes</h6>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6  wow fadeIn" data-wow-delay="0.6s">
                    <div class="potential">
                        <div class="ptl_containt">
                            <div class="loan_img">
                                <img src="images/icons/aumenta-ingresos.png" alt="Aumenta ingresos">
                            </div>
                            <a class="heding">Aumenta tus ingresos</a>
                            <h6>de manera exponencial</h6>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6  wow fadeIn" data-wow-delay="0.3s">
                    <div class="potential">
                        <div class="ptl_containt">
                            <div class="loan_img">
                                <img src="images/icons/agiliza.png" alt="Agiliza tu procedimiento">
                            </div>
                            <a class="heding">Agiliza tu procedimiento</a>
                            <h6>para la venta de automóviles</h6>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6  wow fadeIn">
                    <div class="potential">
                        <div class="ptl_containt">
                            <div class="loan_img">
                                <img src="images/icons/ahorra-tiempo.png" alt="Ahorra tiempo">
                            </div>
                            <a class="heding">Ahorra<br> tiempo</a>
                            <h6>en cerrar ventas</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Potential Area -->

    <!-- Eligibility Criteria Area -->
    <div class="container">
      <div class="holidaying of-credit text-center">
        <h3>¿Por qué Credimóvil?</h3><br>
        <h6>Contamos con más de 25 años de experiencia en el sector financiero automotriz,</h6>
        <h6>somos una herramienta ideal para tus ventas ¡Es momento de ahorrar!</h6>
        <h6>Te brindamos: </h6> <br> <br>
        <div class="col-12 text-center">
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <img src="images/icons/asesoria.png">
              <p><b>Asesoría</b></p>
              <p>Nuestro equipo de expertos en crédito automotriz te asesorarán durante el proceso del crédito y uso de nuestra
                aplicación móvil</p>
            </div>
            <div class="col-md-4 col-sm-12">
                <img src="images/icons/innovacion.png">
                <p><b>Innovación</b></p>
                <p>Contarás con una plataforma exclusiva para crear y dar seguimiento a las solicitudes de crédito de tus clientes</p>
            </div>
            <div class="col-md-4 col-sm-12">
                <img src="images/icons/oportunidad.png">
                <p><b>Oportunidades</b></p>
                <p>Contamos con convenios con distintas instituciones financieras, que permiten que tus clientes tengan mayor
                    posibilidad de acceder a un crédito automotriz</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Eligibility Criteria Area -->

    <!-- Easy cash Area -->
    <section class="easy_cash_area cot-credict" id="ofrece-un-credito">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 back-form">
            <div class="col-12 tittle">
                <h2><span>Si desea ser contactado por un </span> asesor de Credimóvil</h2><br>
                <p>por favor, déjanos tus datos, y conviértete en parte de la comunidad</p>
            </div>
            <form class="from_main" novalidate="novalidate">
                <div class="row">
                    <div class="col-lg-6 select_from">
                        <h6>Nombre de la agencia*</h6>
                        <input type="text" class="post_select" id="loteName" name="loteName" v-model="form.loteName" :class="{ 'error': $v.form.loteName.$invalid }">
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>Dirección*</h6>
                        <input type="text" class="post_select" id="address" name="address" v-model="form.address" :class="{ 'error': $v.form.address.$invalid }">
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>Teléfono 1*</h6>
                        <input type="tel" class="post_select" id="phone1" name="phone1" v-only-numbers v v-model="form.tel1" :class="{ 'error': $v.form.tel1.$invalid }">
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>Teléfono 2</h6>
                        <input type="tel" class="post_select" id="phone2" name="phone2" v-only-numbers v-model="form.tel2" >
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>Teléfono 3</h6>
                        <input type="tel" class="post_select" id="phone3" name="phone3" v-only-numbers v-model="form.tel3" >
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>Correo electrónico*</h6>
                        <input type="email" class="post_select" id="email" name="email" v-model="form.email" :class="{ 'error': $v.form.email.$invalid }">
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>RFC*</h6>
                        <input type="text" class="post_select" id="rfc" name="rfc" v-model="form.rfc" :class="{ 'error': $v.form.rfc.$invalid }">
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>Estado*</h6>
                        <select class="post_select" id="state" :class="{ 'error': $v.form.state.$invalid }">
                          <option value="">Estado</option>
                          <option v-for="state in states">{{state}}</option>
                        </select>
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>Municipio*</h6>
                        <select class="post_select" id="township" :class="{ 'error': $v.form.city.$invalid }" :disabled="form.state == ''">
                          <option value="">Municipio</option>
                          <option v-for="township in townships">{{township}}</option>
                        </select>
                    </div>
                    <div class="col-lg-6 select_from">
                        <h6>Código postal*</h6>
                        <input type="text" class="post_select" id="zipCode" name="zipCode" v-model="form.zipCode" :class="{ 'error': $v.form.zipCode.$invalid }">
                    </div>
                    <!-- <div class="col-lg-6 select_from">
                        <h6>Nombre de la empresa*</h6>
                        <input type="text" class="post_select" id="empresa" name="empresa" v-model="form.company" :class="{ 'error': $v.form.company.$invalid }">
                    </div> -->
                </div>
                <div class="row">
                  <div class="col-12 tittle">
                    <h2><span>Seguridad de cuenta</span></h2><br>
                  </div>
                  <div class="col-lg-6 select_from">
                    <h6>Nombre completo*</h6>
                    <input type="text" class="post_select" id="fullname" name="fullname" v-model="form.fullname" :class="{ 'error': $v.form.fullname.$invalid }">
                  </div>
                  <div class="col-lg-6 select_from">
                    <h6>Nombre de usuario*</h6>
                    <input type="text" class="post_select" id="username" name="username" v-model="form.username" :class="{ 'error': $v.form.username.$invalid }">
                  </div>
                  <div class="col-lg-6 select_from">
                    <h6>Contraseña*</h6>
                    <input type="password" class="post_select" id="password" name="password" v-model="form.password" :class="{ 'error': $v.form.password.$invalid }">
                  </div>
                </div>
                <!-- <div class="select_from">
                    <h6>Inventario de autos*</h6>
                    <input type="text" class="post_select" id="inventario" name="inventario" required>
                </div> -->
                <div class="form-group">
                    <button class="theme_btn btn" id="js-contact-btn" type="button" :disabled="$v.form.$invalid" v-on:click="createBusinessPartner()">Enviar</button>
                    <!-- <div id="js-contact-result" data-success-msg="Form submitted successfully." data-error-msg="Messages Successfully"></div> -->
                </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- End Easy cash Area -->
  </div>
</template>

<script>
  import statesAndTownship from '../assets/estados-municipios.json';
  import { required, minLength, email } from 'vuelidate/lib/validators';

  var regexRfc = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
  export default {
    name: 'BusinessPartners',
    data() {
      return {
        isLoading: false,
        states: [],
        townships: [],
        form: {
          username: '',
          fullname: '',
          email: '',
          password: '',
          loteName: '',
          address: '',
          tel1: '',
          tel2: '',
          tel3: '',
          rfc: '',
          state: '',
          city: '',
          zipCode: ''
        }
      }
    },
    validations() {
      return {
        form: {
          username: { required },
          fullname: { required },
          email: { required, email },
          password: { required, minLength: minLength(12) },
          loteName: { required },
          address: { required },
          tel1: { required },
          rfc: { required, validateRfc: (value) => { return regexRfc.test(value); } },
          state: { required },
          city: { required },
          zipCode: { required }
        }
      }
    },
    methods: {
      refreshSelects() {
        setTimeout(() => {
          $('#state').niceSelect('update');
          $('#township').niceSelect('update');
        }, 100);
      },
      getStates() {
        this.states = Object.keys(statesAndTownship);

        setTimeout(() => {
            this.refreshSelects();

            setTimeout(() => {
                $('#state').on('change', () => {
                  this.form.state = $('#state').val();
                  $('#township').val('');
                  this.form.city = '';

                  this.getTownships();
                });
            }, 100);
        }, 100);
      },
      getTownships() {
        this.townships = statesAndTownship[this.form.state];

        setTimeout(() => {
            this.refreshSelects();

            setTimeout(() => {
                $('#township').on('change', () => {
                  this.form.city = $('#township').val();
                  setTimeout(() => {
                      this.refreshSelects();
                  }, 100);
                });
            }, 100);
        }, 100);
      },
      createBusinessPartner() {
        this.isLoading = true;

        var data = {
          name: this.form.fullname,
          last_name: '',
          email: this.form.email,
          phone: this.form.tel1,
          phone2: this.form.tel2,
          phone3: this.form.tel3,
          state: this.form.state,
          township: this.form.city,
          company: this.form.loteName,
          address: this.form.address,
          postcode: this.form.zipCode,
          rfc: this.form.rfc,
        };


        this.$BusinessPartnersService.createBusinessPartner(this.form).then((result) => {
          this.$UserService.createBusinessPartner({data: data}).then((result) => {
            alert('Tu solicitud fue enviada a revisión con uno de nuestros asesores. Te notificaremos por medio de correo electrónico una vez que quede aprobada. !Gracias por registrarte en Credimóvil!');
            window.location = '/';
            this.isLoading = false;
          }, (err) => {
            this.isLoading = false;
            alert(err.msg)
          });
          
        }, (err) => {
          alert(err.message);
          this.isLoading = false;
        });
      },
    },
    created() {
      this.getStates();
    },
  }
</script>

<style lang="scss">
  .error {
    border-color: red;
    background: #FDD;
  }

  .error:focus {
    outline-color: #F99;
  }

  .nice-select .current {
      width: -webkit-fill-available !important;
      display: block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/views/BusinessPartners.vue